function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3 32V11C3 8.73412 5.53555 7.39206 7.40926 8.66619L16.4902 14.8412C21.6309 18.3369 28.4191 18.2034 33.4183 14.5083L39.0671 10.3331C44.1009 6.61245 51.0772 7.03267 55.6279 11.3306C61.5314 16.9061 70.3334 18.0949 77.5044 14.2853L95.6368 4.65253C97.6793 3.56743 99.9569 3 102.27 3H114.749C119.526 3 122.633 8.02675 120.496 12.2991C119.075 15.1427 118.797 18.4231 119.72 21.4653L124.66 37.738C125.304 39.8592 123.717 42 121.5 42H63.96H13C7.47715 42 3 37.5228 3 32Z",
  stroke: "currentColor",
  strokeWidth: 6
});

function SvgTrack13(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 45,
    viewBox: "0 0 128 45",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrack13);
export default __webpack_public_path__ + "static/media/track13.00ed9d43.svg";
export { ForwardRef as ReactComponent };